export const environment = {
  production: true,
  release: '#{COMMIT_ID}#',
  chargeFuncUrl:
    'https://certistripefunc.azurewebsites.net/api/UpdateOrderToPaid?code=a2yKEIekatwzUqYtt88T4HqDoN6aDtuTjVJKQpgVHfMMkPzOHcYwvA==',
  bancontactFuncUrl:
    'https://certistripefunc.azurewebsites.net/api/BancontactCreateSource?code=vNrtKL5araES5qt0fltE2a3I6btbH2JIO91jIIXqW8YoSKRRHaDjIQ==',
  stripePublicKey: 'pk_live_RPnzJ2n7aIxtPjVP0zVoF9Z3'
};
